import React, { useState, useEffect, useCallback, useRef } from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import Button from '@mui/material/Button';
import config from '../../config';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import getCookie from '../../hooks/getCookie';

const username = getCookie("username");
const sessionId = getCookie("session_id");

const DetailBox = styled('div')(({ theme }) => ({
    backgroundColor: '#313940',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    color: 'white',
    maxWidth: 300,
    minWidth: 280,
    overflowY: 'auto',
}));

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
        ...theme.applyStyles('dark', {
            backgroundColor: '#30404d',
        }),
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
        ...theme.applyStyles('dark', {
            background: 'rgba(57,75,89,.5)',
        }),
    },
    ...theme.applyStyles('dark', {
        boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
        backgroundColor: '#394b59',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
    }),
}));

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});

const inicialColumns = [];

const CopyCard = ({ anchorEl, onClose, selectedCard, handleSetNewTodos, fetchLogs, boardId, addCard, handleCloseDetail }) => {
    const [valor, setValor] = React.useState('');
    const [columns, setColumns] = useState(inicialColumns);
    const [cardName, setCardName] = useState(selectedCard.title);

    const [copyDescription, setCopyDescription] = useState(false);
    const [copyChecklists, setCopyChecklists] = useState(false);
    const [copyTags, setCopyTags] = useState(false);
    const [copyComments, setCopyComments] = useState(false);
    const [copyCover, setCopyCover] = useState(false);
    const [copyMembers, setCopyMembers] = useState(false);

    // ip do backend
    const backendIp = config.backend_ip;

    React.useEffect(() => {
        fetchTiBoardData();
    }, []);

    const handleClose = () => {
        onClose();
    };

    const handleChange = (event) => {
        setValor(event.target.value);
    };

    const fetchTiBoardData = async () => {
        try {
            const response = await axios.put(`${backendIp}/api/board/list_lists`, {
                board_id: boardId,
                username: username,
                session_id: sessionId
            });
            setColumns(response.data);
        } catch (error) {
            return null;
        }
    };

    const handleCardNameChange = (event) => {
        setCardName(event.target.value);
    };

    const open = Boolean(anchorEl);

    return (
        <Box sx={{ width: '100%', position: 'relative' }}>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <DetailBox>
                    <>
                        <p className='titulo-checklist paragraph-members'>Copiar cartão</p>
                        <div style={{ margin: '10px', paddingTop: '15px' }}>
                            <p className='paragraph-copyCard'>Nome do cartão</p>
                            <TextField
                                placeholder='Nome do cartão'
                                variant="outlined"
                                value={cardName}
                                onChange={handleCardNameChange}
                                id="outlined-size-small"
                                size="small"
                                sx={{
                                    width: '280px',
                                    marginRight: '10px',
                                    borderRadius: '6px',
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'var(--textfield-bg-color, #fff)',
                                        color: 'var(--textfield-text-color, #000)',
                                        '& fieldset': {
                                            borderColor: 'var(--textfield-border-color, #ccc)',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'var(--textfield-hover-border-color, #aaa)',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'var(--textfield-focus-border-color)',
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: 'var(--textfield-label-color, #000)',
                                    },
                                    '& .Mui-focused .MuiInputLabel-root': {
                                        color: 'var(--textfield-label-focus-color)',
                                    },
                                    '& .MuiInputBase-input': {
                                        color: 'var(--textfield-text-color, #000)',
                                    },
                                }}
                            />
                            <p className='paragraph-copyCard'>Manter...</p>
                            <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '50px' }}>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        sx={{ '&:hover': { bgcolor: 'transparent' } }}
                                        disableRipple
                                        color="default"
                                        checked={copyDescription}
                                        onChange={(e) => setCopyDescription(e.target.checked)}
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                                    />
                                    <p className='paragraph-checkCopy'>Descrição</p>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        sx={{ '&:hover': { bgcolor: 'transparent' } }}
                                        disableRipple
                                        color="default"
                                        checked={copyCover}
                                        onChange={(e) => setCopyCover(e.target.checked)}
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                                    />
                                    <p className='paragraph-checkCopy'>Capa</p>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        sx={{ '&:hover': { bgcolor: 'transparent' } }}
                                        disableRipple
                                        color="default"
                                        checked={copyMembers}
                                        onChange={(e) => setCopyMembers(e.target.checked)}
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                                    />
                                    <p className='paragraph-checkCopy'>Membros</p>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        sx={{ '&:hover': { bgcolor: 'transparent' } }}
                                        disableRipple
                                        color="default"
                                        checked={copyChecklists}
                                        onChange={(e) => setCopyChecklists(e.target.checked)}
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                                    />
                                    <p className='paragraph-checkCopy'>Checklists</p>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        sx={{ '&:hover': { bgcolor: 'transparent' } }}
                                        disableRipple
                                        color="default"
                                        checked={copyTags}
                                        onChange={(e) => setCopyTags(e.target.checked)}
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                                    />
                                    <p className='paragraph-checkCopy'>Etiquetas</p>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        sx={{ '&:hover': { bgcolor: 'transparent' } }}
                                        disableRipple
                                        color="default"
                                        checked={copyComments}
                                        onChange={(e) => setCopyComments(e.target.checked)}
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                                    />
                                    <p className='paragraph-checkCopy'>Comentários</p>
                                </div>
                            </div>
                            <p style={{ marginLeft: '5px' }} className='paragraph-copyCard'>Copiar para...</p>
                            <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
                                <InputLabel
                                    id="demo-select-small-label"
                                    sx={{
                                        color: 'var(--textfield-label-color, #000)', 
                                        '&.Mui-focused': {
                                            color: 'var(--textfield-label-focus-color, #000)', 
                                        },
                                    }}
                                >
                                    Lista
                                </InputLabel>
                                <Select
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={valor}
                                    label="Lista"
                                    onChange={handleChange}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                backgroundColor: 'var(--dropdown-bg-color, #fff)',
                                                '& .MuiMenuItem-root': {
                                                    color: 'var(--dropdown-text-color, #000)',
                                                    '&:hover': {
                                                        backgroundColor: 'var(--dropdown-hover-bg-color, #f0f0f0)',
                                                    },
                                                    '&.Mui-selected': {
                                                        backgroundColor: 'var(--dropdown-selected-bg-color, #e3f2fd)',
                                                    },
                                                },
                                            },
                                        },
                                    }}
                                    sx={{
                                        backgroundColor: 'var(--textfield-bg-color, #fff)',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'var(--textfield-border-color, #ccc)', 
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'var(--textfield-focus-border-color, #000)', 
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'var(--textfield-hover-border-color, #aaa)', 
                                        },
                                        '.MuiSelect-icon': {
                                            color: 'var(--textfield-icon-color, #000)', 
                                        },
                                        color: 'var(--textfield-text-color, #000)' 
                                    }}
                                >
                                    {columns.map((column, index) => (
                                        <MenuItem key={index} value={column.list_id}>
                                            {column.list_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            < div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    onClick={() => {
                                        addCard(valor, cardName, selectedCard.id, copyChecklists, copyComments, copyTags, copyDescription, copyCover, copyMembers);
                                        handleCloseDetail();
                                    }}
                                    style={{ color: 'white', background: '#424141', border: 'none', borderRadius: '6px', padding: '10px', width: '160px', cursor: 'pointer', fontSize: '15px', marginTop: '15px', marginBottom: '5px' }}
                                    className='button-checklist'
                                >
                                    Copiar cartão
                                </Button>
                            </div>
                        </div>
                    </>
                </DetailBox>
            </Popover>
        </Box>
    );
};

export default CopyCard;
